import { datadogRum as t } from "@datadog/browser-rum";
async function i({
  applicationId: o = process.env.VITE_DD_APP_ID,
  clientToken: e = process.env.VITE_DD_CLIENT_TOKEN,
  env: s = process.env.VITE_APP_ENV,
  service: a = process.env.VITE_APP_NAME,
  ...r
} = {}) {
  if (!o || !e || !s || !a)
    throw new Error("Datadog misconfigured");
  t.init({
    site: "datadoghq.com",
    applicationId: o,
    clientToken: e,
    env: s,
    service: a,
    sampleRate: 100,
    sessionReplaySampleRate: 100,
    ...r
  });
}
export {
  i as initializeDatadog
};
